<script setup>
import { storeToRefs } from 'pinia'
import { useMessageStore } from '~/stores/messages'

definePageMeta({
    ignoreOnBoarding: true
})

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Fetch legal data
const { data: legal, suspense: legalSuspense, isPlaceholderData: isLegalPlaceholderData } = useFetchLegal()

// Prefetch data on the server side
onServerPrefetch(async () => {
    await legalSuspense() // Wait for the query to finish fetching
})

// Track Page Load
trackPageLoad({
    title: TRACKING_CONSTANTS.TITLES.AGB_PAGE,
})
</script>

<template>
    <PageMainContainer>
        <LegalContent
            :legal-content="{
                headline: staticKeys?.menu_agb,
                content: legal?.termsAndConditions?.common?.content,
                placeholder: isLegalPlaceholderData
            }"
        />

        <DevOnly>
            <pre>{{ legal }}</pre>
        </DevOnly>
    </PageMainContainer>
</template>
